import styled from 'styled-components'

export const MessageContainer = styled.div`
	overflow-y: scroll;
	max-height: 700px;
`